import React, { useEffect } from "react";
import { usePlaidLink } from "react-plaid-link";
import type { PlaidLinkOnExit } from "react-plaid-link";

type Props = {
  token: string;
  onExit: PlaidLinkOnExit;
  onSuccess: (publicToken: string) => unknown;
};

const PlaidConnect = ({ token, onSuccess, onExit }: Props): JSX.Element => {
  const { open, ready } = usePlaidLink({
    token,
    onExit,
    onSuccess: (publicToken) => onSuccess(publicToken),
  });

  useEffect(() => {
    if (!ready) {
      return;
    }

    open();
  }, [ ready, open ]);

  return (
    <></>
  );
};

export default PlaidConnect;
